import React from 'react'
import * as Errors from '@morningtrain/react-errors'

export default class Clean extends React.Component {
  render () {
    return (
      <Errors.Boundary>
        {this.props.children}
      </Errors.Boundary>
    )
  }
}
